// src/App.js
import React, { useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import CanCodeQuery from "./components/CanCodeQuery";
import TxtUploader from "./components/TxtUploader";
import Login from "./components/Login";

function App() {
  const [user, setUser] = useState(null);

  const handleLogin = (userData) => {
    setUser(userData);
  };

  return (
    <Routes>
      <Route path="/login" element={<Login onLogin={handleLogin} />} />
      <Route path="/c/:code" element={<CanCodeQuery />} />
      <Route path="/admin/upload" element={<TxtUploader user={user} />} />
    </Routes>
  );
}

export default App;
